<template>
    <div class="header__widgets d-flex">
        <div class="logo">
            <a href="/">
                <img src="/assets/images/logo.png" alt="">
            </a>
        </div>

        <div class="social">
            <ul class="social__list d-flex">
<!--                <li class="social__item"><a href="https://vk.com/saveusby" target="_blank" class="social__link">
                    <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.4551 7.13593C15.0035 6.59429 14.4721 6.13204 13.9693 5.64117C13.5157 5.19872 13.4871 4.94205 13.8517 4.43138C14.2497 3.87403 14.6777 3.33805 15.0793 2.78322C15.4542 2.26469 15.8373 1.74758 16.0346 1.12673C16.1597 0.731741 16.0491 0.557274 15.644 0.488116C15.5742 0.476013 15.5021 0.475385 15.431 0.475385L13.028 0.472556C12.732 0.468155 12.5684 0.597197 12.4637 0.859526C12.3224 1.21412 12.1767 1.5684 12.0084 1.91057C11.6264 2.6864 11.1998 3.43629 10.6018 4.07129C10.4699 4.21133 10.324 4.38831 10.1037 4.31538C9.82799 4.21479 9.74673 3.76055 9.75129 3.60698L9.74893 0.833277C9.69549 0.437034 9.60763 0.260366 9.21421 0.18335L6.71793 0.183821C6.38471 0.183821 6.21763 0.312549 6.03971 0.520966C5.93707 0.641364 5.90611 0.719481 6.11704 0.759404C6.53136 0.837993 6.76476 1.10614 6.82669 1.52156C6.92603 2.18532 6.91911 2.85175 6.8619 3.51818C6.84508 3.71276 6.8116 3.90688 6.73443 4.08858C6.61372 4.37417 6.41882 4.43232 6.16278 4.2566C5.93094 4.09753 5.7681 3.87309 5.60873 3.64769C5.01004 2.80177 4.53238 1.88951 4.14289 0.930885C4.03035 0.653938 3.83624 0.486073 3.54279 0.481515C2.82182 0.470041 2.10069 0.468155 1.37972 0.482143C0.945907 0.490317 0.81655 0.700934 0.993217 1.09419C1.77847 2.8409 2.65254 4.53904 3.79349 6.08598C4.37929 6.87989 5.05185 7.58074 5.92072 8.07742C6.90544 8.64043 7.96544 8.80986 9.08187 8.75768C9.60464 8.73316 9.76166 8.5972 9.78587 8.07616C9.80221 7.71968 9.84261 7.36525 10.0185 7.04492C10.1911 6.73057 10.4525 6.67068 10.7538 6.86621C10.9045 6.96413 11.0315 7.08877 11.1514 7.22017C11.4457 7.54207 11.7294 7.87372 12.0348 8.18477C12.4178 8.57457 12.8716 8.80484 13.4421 8.75784L15.6508 8.75831C16.0066 8.73505 16.1912 8.29873 15.9868 7.90154C15.8433 7.62333 15.655 7.37562 15.4551 7.13593Z" fill="#75808F"/>
                    </svg>
                </a></li>
                <li class="social__item"><a href="https://www.facebook.com/saveus.by" target="_blank" class="social__link">
                    <svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.75667 4.93519L5.62068 6.94254H3.76689V13.3333H1.41924V6.94254H0.166687V4.93519H1.41924V4.3084V3.68953V3.58639C1.41924 2.99133 1.43356 2.0789 1.82006 1.50764C2.22804 0.904642 2.79348 0.5 3.75973 0.5C5.33438 0.5 6.00002 0.745958 6.00002 0.745958L5.68509 2.80091C5.68509 2.80091 5.1626 2.63429 4.67589 2.63429C4.18918 2.63429 3.75258 2.82471 3.75258 3.36423V3.58639V4.3084V4.93519H5.75667Z" fill="#2E76E4"/>
                    </svg>
                </a></li>-->
                <li class="social__item"><a href="https://www.instagram.com/bypet.by/" target="_blank" class="social__link">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.98807 0.083313H4.01188C2.97092 0.0864219 1.97348 0.501322 1.2374 1.2374C0.501322 1.97348 0.0864219 2.97092 0.083313 4.01188V8.98807C0.0864219 10.029 0.501322 11.0265 1.2374 11.7626C1.97348 12.4986 2.97092 12.9135 4.01188 12.9166H8.98807C10.029 12.9135 11.0265 12.4986 11.7626 11.7626C12.4986 11.0265 12.9135 10.029 12.9166 8.98807V4.01188C12.9135 2.97092 12.4986 1.97348 11.7626 1.2374C11.0265 0.501322 10.029 0.0864219 8.98807 0.083313Z" fill="#6C4DBB"/>
                        <path d="M9.92327 2.30945C9.77486 2.30945 9.62979 2.35346 9.50639 2.43591C9.383 2.51836 9.28682 2.63555 9.23003 2.77266C9.17324 2.90977 9.15838 3.06064 9.18733 3.20619C9.21628 3.35175 9.28775 3.48545 9.39269 3.59039C9.49763 3.69533 9.63133 3.76679 9.77688 3.79574C9.92244 3.8247 10.0733 3.80984 10.2104 3.75305C10.3475 3.69625 10.4647 3.60008 10.5472 3.47668C10.6296 3.35329 10.6736 3.20821 10.6736 3.05981C10.6736 2.96127 10.6542 2.86369 10.6165 2.77266C10.5788 2.68162 10.5235 2.5989 10.4539 2.52922C10.3842 2.45955 10.3015 2.40427 10.2104 2.36657C10.1194 2.32886 10.0218 2.30945 9.92327 2.30945Z" fill="#F1EEF9"/>
                        <path d="M9.70811 6.5002C9.70811 8.27212 8.27169 9.70854 6.49978 9.70854C4.72786 9.70854 3.29144 8.27212 3.29144 6.5002C3.29144 4.72829 4.72786 3.29187 6.49978 3.29187C8.27169 3.29187 9.70811 4.72829 9.70811 6.5002ZM4.62951 6.5002C4.62951 7.53312 5.46686 8.37047 6.49978 8.37047C7.5327 8.37047 8.37004 7.53312 8.37004 6.5002C8.37004 5.46728 7.5327 4.62993 6.49978 4.62993C5.46686 4.62993 4.62951 5.46728 4.62951 6.5002Z" fill="#F1EEF9"/>
                    </svg>
                </a></li>
            </ul>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Logo"
    }
</script>

<style scoped lang="scss">
    .logo{
        width: 100%;
        max-width: 105px;
        svg{
            width: 100%;
            height: auto;
        }

        @media screen and (max-width: 992px){
            max-width: 130px;
        }
    }

    .social{

        &__list{
            padding: 0;
            margin: 0;
            list-style: none;
            justify-content: flex-end;
            align-items: center;
        }
        &__item{
            margin-right: 10px;

            &:last-child{
                margin-right: 0;
            }
        }

        &__link{
            display: block;
            position: relative;
            width: 35px;
            height: 35px;
            background-color: #EAF1FC;
            border-radius: 100%;
            overflow: hidden;
            transition: opacity .2s ease;
            svg{
                position: absolute;
                left: 50%;
                top: 50%;

                transform: translate(-50%,-50%);
            }

            &:hover{
                opacity: .8;
            }
        }


    }

    @media screen and (min-width: 768px){
        .social{
            display: none;
        }
    }

    @media screen and (max-width: 768px){
        .header__widgets{
            justify-content: space-between;
            margin-bottom: 10px;
        }
    }


</style>
